import { STYLES } from "./data/styles";
import { els } from "./ui/elements";
import {
  loadStyle, syncYeastUI, refreshAutoYeast, calc, setChip, applySnapshot,
  setUnitSystem, applyUnits,
} from "./ui/controls";
import { renderHistory } from "./ui/render";
import { wire } from "./ui/wire";
import { decodeState } from "./share/url";

export function init(): void {
  // Populate styles dropdown.
  STYLES.forEach((s) => {
    const o = document.createElement("option");
    o.value = s.id; o.textContent = s.name;
    els.style.appendChild(o);
  });
  loadStyle(STYLES[0]!);
  syncYeastUI();
  els.timeOut.textContent = els.time.value + " h";
  setChip(els.timeChips, "time", +els.time.value);
  setChip(els.tempChips, "temp", +els.temp.value);
  refreshAutoYeast();
  wire();
  renderHistory();
  const shared = decodeState(location.hash);
  if (shared) applySnapshot(shared);
  else calc();
  // Restore device-local unit preference and paint the display in it.
  let storedUnits: string | null = null;
  try { storedUnits = localStorage.getItem("units"); } catch { storedUnits = null; }
  const sys = storedUnits === "us" ? "us" : "metric";
  setUnitSystem(sys);
  document.querySelectorAll<HTMLButtonElement>('#unitToggle button[data-units]')
    .forEach((b) => b.setAttribute("aria-pressed", String(b.dataset.units === sys)));
  applyUnits();
}
